const BahasaRobotik: React.FC = () => {
    return (
        <div  className="text-justify py-4">
            <h2 className="text-lg font-semibold mb-3">🤖 Bahasa Pemrograman Terbaik untuk Proyek Robotik Pemula</h2>
            <p className="mb-4">
                Ingin bikin robot sederhana tapi bingung pakai bahasa pemrograman apa? Tenang! Berikut beberapa bahasa yang paling sering dipakai dalam proyek robotik pemula, lengkap dengan kelebihan dan kekurangannya 👇
            </p>

            <h3 className="text-md font-semibold text-gray-800 mb-2">1️⃣ Arduino (C/C++)</h3>
            <p className="mb-4">
                Bahasa paling populer untuk proyek robotik dasar seperti line follower, pengukur suhu, atau robot sensor. Langsung terhubung ke board Arduino dan punya komunitas besar.
                <br />
                <strong>✔️ Kelebihan:</strong> Real-time, ringan, dokumentasi melimpah.<br />
                <strong>❌ Kekurangan:</strong> Agak sulit untuk pemula yang belum pernah ngoding.
            </p>

            <h3 className="text-md font-semibold text-gray-800 mb-2">2️⃣ Python</h3>
            <p className="mb-4">
                Mudah dipahami dan digunakan di robot yang memerlukan AI, machine learning, atau computer vision (misalnya dengan OpenCV dan Raspberry Pi).
                <br />
                <strong>✔️ Kelebihan:</strong> Sintaks sederhana, cocok untuk AI dan analisis data.<br />
                <strong>❌ Kekurangan:</strong> Tidak real-time dan butuh board yang mendukung OS (seperti Raspberry Pi).
            </p>

            <h3 className="text-md font-semibold text-gray-800 mb-2">3️⃣ Scratch for Arduino (S4A)</h3>
            <p className="mb-4">
                Bahasa visual berbasis blok, cocok banget untuk anak-anak atau pemula total yang baru belajar logika pemrograman dan robotik.
                <br />
                <strong>✔️ Kelebihan:</strong> Visual, menyenangkan, ramah pemula.<br />
                <strong>❌ Kekurangan:</strong> Kurang fleksibel untuk proyek yang kompleks.
            </p>

            <h3 className="text-md font-semibold mb-2">🛠️ Tips Memilih Bahasa</h3>
            <p className="mb-4">
                Pilih bahasa yang sesuai dengan:
                <ul className="list-disc list-inside mt-2">
                    <li>🔧 Kebutuhan teknis proyek (misal: kontrol motor vs. kamera AI)</li>
                    <li>👥 Kemampuan dan pengalaman tim kamu</li>
                    <li>📦 Ketersediaan perangkat keras dan library yang didukung</li>
                </ul>
            </p>

            <p className="text-gray-700">
                Intinya, gak ada bahasa yang “paling benar”, yang terbaik adalah yang paling cocok untuk proyekmu. Mulailah dari yang kamu kuasai, lalu kembangkan kemampuanmu seiring kompleksitas proyek 🚀
            </p>
        </div>
    )
}
export default BahasaRobotik